import React from 'react'

import { scrollToTop } from 'shared/utils/dom'

const ScrollResetter = () => {
  React.useEffect(() => {
    scrollToTop()
  }, [])

  return null
}

export default ScrollResetter
